import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { ShareOpportunity } from "./mutations";
import DefaultToaster from "../../../../atoms/DefaultToaster";
import { Intent } from "@blueprintjs/core";
import { isEmail } from "validator";

const useEmailTab = ({ opportunityId, onDismiss, setShowShare }) => {
  const [emails, setEmails] = useState();
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [invalidForm, setInvalidForm] = useState(false);
  const [error, setError] = useState(false);

  const [shareOpportunity] = useMutation(ShareOpportunity);

  const onSendEmails = async () => {
    setLoading(true);
    try {
      const {
        data: { shareOpportunity: response }
      } = await shareOpportunity({
        variables: {
          opportunityId,
          emails,
          description
        }
      });

      if (response === "NotShared") {
        setError(getError());
      }

      DefaultToaster.show({
        message: `${
          emails.length === 1 ? "Email" : "Emails"
        } Sent Successfully`,
        icon: "tick",
        intent: Intent.SUCCESS
      });

      setLoading(false);
      setShowShare(false);
      onDismiss();
    } catch (err) {
      setError(getError());
      setLoading(false);
    }
  };

  const onEmailsChange = (event) => {
    let emails = event.target.value;
    if (emails) {
      emails = [...new Set(emails.replace(/\s/g, "").split(","))];
      setInvalidForm(false);
      for (const email of emails) {
        if (!isEmail(email)) {
          setInvalidForm(true);
          break;
        }
      }
    }
    setEmails(emails);
  };

  return {
    emails,
    setDescription,
    loading,
    isAlertOpen,
    setIsAlertOpen,
    invalidForm,
    error,
    onEmailsChange,
    onSendEmails
  };
};

const getError = () => {
  return {
    message: (
      <span>
        Something went wrong! Try again or contact{" "}
        {
          <a
            href="https://help.videosquirrel.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            support
          </a>
        }{" "}
        if the problem persists.
      </span>
    )
  };
};

export default useEmailTab;
